<template>
    <div class="p-6" id="sms_history">
        <div class="vx-row">
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full">
                <label class="vs-input--label">Tổng đài</label>
                <v-select class="w-full" v-model="smsSendInfo.smsBrandNameId"
                          :options="brandNameOptions" :reduce="item => item.value">
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full sm:mt-0 mt-4">
                <label class="vs-input--label">Loại tin nhắn</label>
                <v-select class="w-full" v-model="smsSendInfo.messageType"
                          :options="messageTypeOptions" :reduce="item => item.value">
                </v-select>
            </div>
            <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full md:mt-6 mt-4">
                <vs-button class="" icon-pack="feather" icon="icon-search" @click="filter">Tìm kiếm</vs-button>
            </div>
        </div>

        <ag-grid-vue style="height: 55vh" ref="agGridTable" :gridOptions="gridOptions"
                     class="ag-theme-material w-100 my-4 ag-grid-table" :columnDefs="columnDefs"
                     :defaultColDef="defaultColDef"
                     :rowData="historySMSData" :animateRows="true"
                     :localeText="{ noRowsToShow: this.$t('menuCustomer.noRowsToShow') }"
                     :onGridReady="onGridReady" :suppressPaginationPanel="true">
        </ag-grid-vue>

        <div class="vx-row" v-if="historySMSData.length > 0">
            <div class="vx-col md:w-1/2">
                <div class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4 vx-row">
                    <span class="vx-col mt-2">Số phần tử / trang:</span>
                    <vs-dropdown vs-trigger-click class="cursor-pointer">
                        <div
                            class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium vx-col">
                            <span class="mr-2">
                                {{
                                    historySMSData.length - currentPage * pageSize > 0 ? currentPage *
                                        pageSize
                                        : historySMSData.length
                                }} /
                                {{ totalElements }}</span>
                            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
                        </div>
                        <vs-dropdown-menu>
                            <vs-dropdown-item @click="changePageSize(20)">
                                <span>20</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(30)">
                                <span>30</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(50)">
                                <span>50</span>
                            </vs-dropdown-item>
                            <vs-dropdown-item @click="changePageSize(100)">
                                <span>100</span>
                            </vs-dropdown-item>
                        </vs-dropdown-menu>
                    </vs-dropdown>
                </div>
            </div>
            <div class="vx-col md:w-1/2 w-full">
                <vs-pagination :total="totalPages" v-model="currentPage" @change="loadPage"/>
            </div>
        </div>
    </div>
</template>

<script>

import vSelect from 'vue-select';
import {AgGridVue} from "ag-grid-vue";
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss';
import moment from "moment";
import CellRendererActions from "./cell-renderer/CellRendererActions";
import { ClientSideRowModelModule } from '@ag-grid-community/client-side-row-model';
import { ModuleRegistry } from '@ag-grid-community/core';

ModuleRegistry.registerModules([ClientSideRowModelModule]);

export default {
    name: "HistorySMS",
    components: {
        vSelect,
        AgGridVue,
        CellRendererActions
    },
    props: {
        loyaltyCustomerId: {
            default: null,
            type: Number,
        },
    },
    data() {
        return {
            brandNameOptions: [],
            messageTypeOptions: [
                {value: null, label: 'Tất cả'},
                {value: 1, label: 'Chăm sóc khách hàng'},
                {value: 2, label: 'Quảng cáo'},
            ],
            smsSendInfo: {
                messageType: null,
                smsBrandNameId: 'null',
            },
            historySMSData: [],
            gridApi: null,
            gridOptions: {},
            defaultColDef: {
                resizable: true,
            },
            columnDefs: [
                {
                    headerName: this.$t('menuCustomer.stt'),
                    field: 'stt',
                    width: 100,
                },
                {
                    headerName: 'Thời gian',
                    field: 'sendTimeStr',
                    minWidth: 100,
                },
                {
                    headerName: 'Nội dung',
                    field: 'message',
                    minWidth: 300,
                },
                {
                    headerName: 'Hành động',
                    field: 'actions',
                    width: 120,
                    cellRendererFramework: 'CellRendererActions',
                    suppressSizeToFit: true,
                    pinned: 'right'
                },
            ],
            pageNumber: 0,
            pageSize: 20,
            totalPages: 0,
            currentPage: 1,
            totalElements: 0,
        }
    },

    watch: {
        '$store.state.windowWidth'(val) {
            if (val > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },
        '$store.state.reduceButton'() {
            setTimeout(() => {
                this.gridApi.sizeColumnsToFit();
            }, 650);
        },
    },

    async created() {
        await this.getBrandName();
        this.getHistorySMS();
    },

    methods: {
        getBrandName() {
            return new Promise((resolve, reject) => {
                this.$vs.loading();
                this.$crm.post('/sms-brand-name/get-all').then(res => {
                    if (res.data && res.data.length > 0) {
                        this.brandNameOptions = res.data.map(el => {
                            return {
                                value: el.id,
                                label: el.brandName,
                            }
                        })
                    }
                    this.brandNameOptions.unshift({value: 'null', label: 'Tất cả'});
                    this.$vs.loading.close();
                    resolve(res);
                }).catch((err) => {
                    reject(err)
                    this.$vs.loading.close();
                    return this.$vs.notify({
                        title: 'Error',
                        text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                        iconPack: 'feather',
                        icon: 'icon-alert-circle',
                        color: 'danger'
                    });
                });
            })
        },

        getHistorySMS() {
            let payload = {
                messageType: this.smsSendInfo.messageType,
                smsBrandNameId: JSON.parse(this.smsSendInfo.smsBrandNameId),
                loyaltyCustomerId: this.loyaltyCustomerId,
            }
            this.historySMSData = [];
            this.$vs.loading();
            this.$crm.post('/sms/find-by-condition', payload).then(res => {
                this.$vs.loading.close();
                if (res.data.content && res.data.content.length > 0) {
                    this.historySMSData = res.data.content.map(el => {
                        el.stt = this.pageNumber * this.pageSize + res.data.content.indexOf(el) + 1;
                        el.sendTimeStr = moment(el.sendTime).format('DD/YY/YYYY HH:mm:ss')
                        return el;
                    })
                }
                this.totalPages = res.data.totalPages;
                this.totalElements = res.data.totalElements;
            }).catch((err) => {
                this.$vs.loading.close();
                return this.$vs.notify({
                    title: 'Error',
                    text: err.response.data.message || err.response.data.error_description || err.response.data.error,
                    iconPack: 'feather',
                    icon: 'icon-alert-circle',
                    color: 'danger'
                });
            });
        },

        onGridReady() {
            if (this.$store.state.windowWidth > 1024) {
                this.gridApi.sizeColumnsToFit();
            }
        },

        loadPage: function (currentPage) {
            if (this.pageNumber !== parseInt(currentPage) - 1) {
                this.pageNumber = parseInt(currentPage) ? parseInt(currentPage) - 1 : 0;
                this.getHistorySMS();
            }
        },

        changePageSize(number) {
            this.pageSize = number;
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getHistorySMS();
        },

        filter() {
            this.pageNumber = 0;
            this.currentPage = 1;
            this.getHistorySMS();
        },
    },

    mounted() {
        this.gridApi = this.gridOptions.api;
    },
}
</script>

<style scoped>

</style>
